/** Hash routes for public marketing + app shell (no react-router). */

const PUBLIC_ROUTES = {
  "": "landing",
  home: "landing",
  signup: "signup",
  signin: "signin",
  "sign-up": "signup",
  "sign-in": "signin",
  login: "signin",
};

const APP_PAGE_ALIASES = {
  app: "dashboard",
  console: "dashboard",
  dashboard: "dashboard",
  "intellirag-tutor": "ai-tutor",
};

export const APP_PAGE_IDS = new Set([
  "dashboard",
  "chat",
  "logs",
  "incidents",
  "changes",
  "cmdb",
  "kb",
  "docs",
  "learn-topics",
  "learn-k8s",
  "agents",
  "architecture",
  "intellirag-it",
  "ai-tutor",
  "analytics",
  "users",
  "billing",
  "apikeys",
  "integrations",
  "audit",
  "notifs",
  "settings",
]);

function hashPath() {
  const raw = (window.location.hash || "#/").replace(/^#\/?/, "").trim();
  const segment = raw.split("?")[0].replace(/\/$/, "");
  return segment || "";
}

/** Normalize `#/app/chat`, `#/chat`, `chat` → page id or null. */
export function parseAppPageId(path) {
  if (!path || path === "landing") return null;
  if (APP_PAGE_ALIASES[path]) return APP_PAGE_ALIASES[path];
  if (APP_PAGE_IDS.has(path)) return path;

  if (path.startsWith("app/")) {
    const sub = path.slice(4);
    if (!sub) return "dashboard";
    if (APP_PAGE_ALIASES[sub]) return APP_PAGE_ALIASES[sub];
    if (APP_PAGE_IDS.has(sub)) return sub;
  }

  if (path.startsWith("app")) {
    const rest = path.replace(/^app\/?/, "");
    if (!rest) return "dashboard";
    if (APP_PAGE_ALIASES[rest]) return APP_PAGE_ALIASES[rest];
    if (APP_PAGE_IDS.has(rest)) return rest;
  }

  return null;
}

/** Top-level shell route: landing | signup | signin | app */
export function getRoute() {
  const path = hashPath();
  if (PUBLIC_ROUTES[path] !== undefined) return PUBLIC_ROUTES[path];
  if (path === "app" || parseAppPageId(path)) return "app";
  return "landing";
}

/** Screen id inside the authenticated app shell. */
export function getAppPage(fallback = "dashboard") {
  const path = hashPath();
  return parseAppPageId(path) || fallback;
}

/** Canonical hash for an app screen (shareable links). */
export function appPageHash(pageId) {
  const id = pageId === "dashboard" ? "dashboard" : pageId;
  if (!APP_PAGE_IDS.has(id) && id !== "dashboard") return "#/app";
  if (id === "dashboard") return "#/app";
  return `#/app/${id}`;
}

export function navigate(route) {
  const map = {
    landing: "#/",
    signup: "#/signup",
    signin: "#/signin",
    app: "#/app",
    dashboard: "#/app",
  };
  if (map[route]) {
    window.location.hash = map[route];
    return;
  }
  if (APP_PAGE_IDS.has(route)) {
    window.location.hash = appPageHash(route).replace(/^#/, "");
    return;
  }
  window.location.hash = `#/${route}`;
}
